<template>
  <div class="preloader-wrapper active" v-bind:class="sizeClass">
    <div class="spinner-layer spinner-teal-only">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div>
      <div class="gap-patch">
        <div class="circle"></div>
      </div>
      <div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.preloader-wrapper.tiny {
    width: 24px;
    height: 24px;
}
</style>
<script>
export default {
  name: "spinner",
  props: {
      size: String
  },
  computed:{
      sizeClass(){
          const classes = {
              'big': 'big',
              'small': 'small',
              'tiny': 'tiny',
              'default': ''
          }
          return (classes[this.size] || classes['default'])
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Spinner.vue